/* assets/ahm-stock.js — the STOCK GALLERY view (slot 'stock'): every collection page + the Saved cars page.
   Shopify version of the mockup's js/stock.js. Liquid (sections/main-stock.liquid) server-renders the head,
   the first 24 cars and a pager; once the collection feed has loaded this script takes over: it replaces the
   grid with the full filtered list (rendered in chunks, so 1,200+ cars stay fast), hides the pager and keeps
   the filters in the query string with history.replaceState (no reload, no scroll reset).
   Reads cars only from ctx.cars (= the feed of THIS collection; the Saved page loads the all-products feed). */
(function () {
  'use strict';
  if (!window.M) return;

  var NON_ROAD = /tractor|truck|bus|motorbike|motorcycle/i;   /* "specialist vehicles" sort last */
  var MULTI = ['body', 'fuel', 'trans', 'drive'];
  var GROUP = { body: 'Body', fuel: 'Fuel', trans: 'Transmission', drive: 'Drive' };
  var KM_OPTS = [10000, 30000, 50000, 80000, 100000, 150000];
  var SORTS = [['best', 'Best match'], ['newest', 'Newest first'], ['km', 'Lowest mileage'], ['make', 'Make A to Z']];
  var CHUNK = 48;                                                /* cards per "Show more" step */

  var S = blank();
  var root = null, slotEl = null, railNode = null, railHost = null, drawer = null, qTimer = 0, lastCtx = null, lastRoute = null;
  var CFG = {}, res = [], limit = CHUNK, took = false;

  function blank() { return { q: '', need: '', status: '', loc: '', make: '', model: '', ymin: '', ymax: '', kmax: '', body: [], fuel: [], trans: [], drive: [], sort: 'best', saved: false }; }
  function slug(s) { return String(s == null ? '' : s).toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }
  function esc(s) { return M.esc(s); }
  function cars() { return (lastCtx && lastCtx.cars) || M.cars; }
  function uniq(a) { return a.filter(function (v, i) { return v && a.indexOf(v) === i; }); }
  function plural(n, one, many) { return n === 1 ? one : many; }
  function findUrl() { return (M.urls && M.urls.find) || '/pages/find-me-a-car'; }
  function allUrl() { return (M.urls && M.urls.stock) || '/collections/all'; }

  /* display label for a slugged value */
  function display(field, s) {
    var all = M.all;
    for (var i = 0; i < all.length; i++) if (slug(all[i][field]) === s) return all[i][field];
    return s;
  }

  /* ---------- params <-> state ---------- */
  function fromParams(p) {
    p = p || {};
    var s = blank();
    s.q = String(p.q || '').slice(0, 80);
    s.need = p.need && M.need(p.need) ? M.need(p.need).key : '';
    s.status = p.status === 'in' || p.status === 'way' ? p.status : '';
    s.loc = /^(nairobi|mombasa)$/i.test(p.loc || '') ? String(p.loc).toLowerCase() : '';
    s.make = slug(p.make); s.model = s.make ? slug(p.model) : '';
    s.ymin = /^\d{4}$/.test(p.ymin || '') ? p.ymin : '';
    s.ymax = /^\d{4}$/.test(p.ymax || '') ? p.ymax : '';
    s.kmax = /^\d+$/.test(p.kmax || '') ? p.kmax : '';
    MULTI.forEach(function (k) { s[k] = uniq(String(p[k] || '').split(',').map(slug)); });
    s.sort = SORTS.some(function (o) { return o[0] === p.sort; }) ? p.sort : 'best';
    s.saved = p.saved === '1' || p.saved === 'true' || p.saved === 1;
    return s;
  }
  function toParams() {
    if (S.saved) return { saved: 1 };
    var p = { need: S.need, q: S.q.trim(), status: S.status, loc: S.loc, make: S.make, model: S.model, ymin: S.ymin, ymax: S.ymax, kmax: S.kmax };
    MULTI.forEach(function (k) { p[k] = S[k].join(','); });
    if (S.sort !== 'best') p.sort = S.sort;
    return p;
  }
  function writeUrl() {
    var u = M.stockUrl(toParams());
    if (location.pathname + location.search !== u) { try { history.replaceState(history.state, '', u); } catch (e) { /* ignore */ } }
  }

  /* ---------- matching / facets ---------- */
  var SYN = { '4x4': '4wd', 'auto': 'automatic', 'manual': 'manual', 'suv': 'suv', 'van': 'minivan', 'mpv': 'minivan', 'pickup': 'pickup', 'pick-up': 'pickup', 'ev': 'electric' };
  function hay(c) {
    if (c.__stHay) return c.__stHay;
    var bits = [c.title, c.make, c.model, c.grade, c.ref, M.shortRef(c), c.body, c.fuel, c.trans, c.drive, c.colour, c.loc, c.cond, c.engine,
      c.status === 'in' ? 'here now in stock' : 'arriving on the way', c.drive === '4WD' ? '4x4' : ''];
    M.needsOf(c).forEach(function (k) { var n = M.need(k); if (n) bits.push(n.label); });
    return (c.__stHay = bits.join(' ').toLowerCase());
  }
  function qMatch(c, q) {
    var h = hay(c);
    return q.toLowerCase().split(/\s+/).filter(Boolean).every(function (t) { t = SYN[t] || t; return h.indexOf(t) > -1; });
  }
  function yr(c) { var y = Number(c.year); return isFinite(y) ? y : 0; }
  function matches(c, s, skip) {
    if (skip !== 'need' && s.need) { var n = M.need(s.need); if (n && !n.test(c)) return false; }
    if (skip !== 'status' && s.status && c.status !== s.status) return false;
    /* showroom = cars HERE NOW in that city (a car at Mombasa port is arriving, not in the showroom) */
    if (skip !== 'loc' && s.loc && (c.status !== 'in' || slug(c.loc) !== s.loc)) return false;
    if (skip !== 'make' && s.make && slug(c.make) !== s.make) return false;
    if (skip !== 'make' && skip !== 'model' && s.model && slug(c.model) !== s.model) return false;
    if (skip !== 'year') { if (s.ymin && yr(c) < +s.ymin) return false; if (s.ymax && yr(c) > +s.ymax) return false; }
    /* up to N km; a machine with no mileage reading never passes a mileage filter */
    if (skip !== 'kmax' && s.kmax && (!M.kmKnown(c) || c.km > +s.kmax)) return false;
    for (var i = 0; i < MULTI.length; i++) { var k = MULTI[i]; if (skip !== k && s[k].length && s[k].indexOf(slug(c[k])) < 0) return false; }
    if (skip !== 'q' && s.q.trim() && !qMatch(c, s.q)) return false;
    return true;
  }
  function facet(skip) { return cars().filter(function (c) { return matches(c, S, skip); }); }
  function countBy(list, field) { var o = {}; list.forEach(function (c) { var k = slug(c[field]); o[k] = (o[k] || 0) + 1; }); return o; }
  function valuesOf(field) { /* option list from this collection, in a sensible order */
    var seen = {}; cars().forEach(function (c) { if (c[field]) seen[slug(c[field])] = c[field]; });
    return Object.keys(seen).sort(function (a, b) { return String(seen[a]).localeCompare(String(seen[b])); }).map(function (k) { return { v: k, label: seen[k] }; });
  }

  function rank(c) { return NON_ROAD.test(c.body || '') ? 2 : (c.status === 'in' ? 0 : 1); }
  function kmv(c) { return M.kmKnown(c) ? Number(c.km) || 0 : Infinity; }   /* unknown mileage sorts last */
  function kmCmp(x, y) { var a = kmv(x), b = kmv(y); return a === b ? 0 : a < b ? -1 : 1; }
  function nophoto(c) { return c.photos && c.photos.length ? 0 : 1; }       /* cars with photos lead their rank */
  function unchecked(c) { return c.hero === true ? 0 : 1; }                 /* then cars whose first photo is checked clean */
  function sortCars(list) {
    var k = S.sort;
    return list.slice().sort(function (x, y) {
      if (k === 'newest') return yr(y) - yr(x) || kmCmp(x, y);
      if (k === 'km') return kmCmp(x, y) || yr(y) - yr(x);
      if (k === 'make') return (x.make + ' ' + x.model).localeCompare(y.make + ' ' + y.model) || yr(y) - yr(x);
      return rank(x) - rank(y) || nophoto(x) - nophoto(y) || unchecked(x) - unchecked(y) || yr(y) - yr(x) || kmCmp(x, y) || String(x.ref).localeCompare(String(y.ref));
    });
  }

  /* ---------- active filters (pills, summaries) ---------- */
  function active() {
    var a = [];
    if (S.q.trim()) a.push({ k: 'q', label: '“' + S.q.trim() + '”' });
    if (S.need) a.push({ k: 'need', label: M.need(S.need).label });
    if (S.status) a.push({ k: 'status', label: S.status === 'in' ? 'Here now' : 'Arriving' });
    if (S.make) a.push({ k: 'make', label: display('make', S.make) });
    if (S.model) a.push({ k: 'model', label: display('model', S.model) });
    if (S.ymin || S.ymax) a.push({ k: 'year', label: S.ymin && S.ymax ? (S.ymin === S.ymax ? S.ymin : S.ymin + ' to ' + S.ymax) : S.ymin ? 'From ' + S.ymin : 'Up to ' + S.ymax });
    if (S.kmax) a.push({ k: 'kmax', label: 'Up to ' + M.km(S.kmax) });
    if (S.loc) a.push({ k: 'loc', label: S.loc === 'nairobi' ? 'Nairobi' : 'Mombasa' });
    MULTI.forEach(function (k) { S[k].forEach(function (v) { a.push({ k: k, v: v, label: display(k, v) }); }); });
    return a;
  }
  function railActiveCount() { return active().filter(function (f) { return f.k !== 'q' && f.k !== 'need'; }).length; }
  function removeFilter(k, v) {
    if (k === 'year') { S.ymin = ''; S.ymax = ''; }
    else if (k === 'make') { S.make = ''; S.model = ''; }
    else if (MULTI.indexOf(k) > -1) S[k] = S[k].filter(function (x) { return x !== v; });
    else S[k] = '';
    if (k === 'q') { var qi = root.querySelector('[data-st-q]'); if (qi) qi.value = ''; var qc = root.querySelector('[data-st-qclear]'); if (qc) qc.hidden = true; }
  }
  function clearAll() {
    var keep = S.sort; S = blank(); S.sort = keep;
    var qi = root.querySelector('[data-st-q]'); if (qi) qi.value = '';
    var qc = root.querySelector('[data-st-qclear]'); if (qc) qc.hidden = true;
  }

  /* ---------- network numbers (from the shop metafield ahm.network; network inventory, not owned) ---------- */
  function ns() { return M.networkSummary(); }
  function hasNet() { var s = ns(); return (s.here + s.way + s.total) > 0; }
  function asOf() { return ns().date || ''; }
  function held() { return ns().held || 'partner showrooms'; }
  function netMake(mk) { var bm = (M.network && M.network.byMake) || {}; var m = mk && bm[mk]; return m && ((m.in || 0) + (m.way || 0)) > 0 ? m : null; }
  /* the make this view is about: the Make filter, else a collection titled after a make in the network */
  function viewMake() { if (S.make) return display('make', S.make); return netMake(CFG.coll) ? CFG.coll : ''; }

  /* ================= render: head ================= */
  function renderHead() {
    var list = cars(), n = list.length;
    var title = root.querySelector('[data-st-title]'), truth = root.querySelector('[data-st-truth]');
    var eb = root.querySelector('[data-st-eyebrow]'), aside = root.querySelector('[data-st-head-aside]');
    var tiers = root.querySelector('[data-st-tiers]');
    root.classList.toggle('st--saved', S.saved);

    if (S.saved) {
      var sv = list.filter(function (c) { return M.isSaved(c.ref); });
      var hidden = Array.from(M.saved).filter(function (r) { return !list.some(function (c) { return c.ref === r; }); }).length;
      eb.textContent = 'Kept on this device';
      title.textContent = CFG.heading || 'Saved cars';
      truth.innerHTML = '<span class="t-num">' + M.fmt(sv.length) + '</span> ' + plural(sv.length, 'car', 'cars') + ' saved in this browser. Prices on request.' +
        (hidden ? ' <span class="st-truth-note">' + M.fmt(hidden) + ' more saved ' + plural(hidden, 'car is', 'cars are') + ' not published online right now.</span>' : '');
      var msg = sv.length ? 'Hi AHIHQ Motors, I have saved these cars: ' + sv.map(function (c) { return c.title + ' (Ref ' + c.ref + ')'; }).join('; ') + '. Are they still available?' : '';
      aside.innerHTML = '<a class="text-link" href="' + esc(allUrl()) + '"><span class="arr" aria-hidden="true">←</span> All stock</a>' +
        (sv.length ? '<a class="btn btn--secondary btn--sm st-wa-list" ' + M.waAttrs(msg) + '>' + M.icon('whatsapp', { size: 18 }) + 'Ask about these</a>' : '');
      tiers.hidden = true;
      return;
    }

    var d = asOf();
    eb.innerHTML = '<span>' + esc(CFG.eyebrow || 'Stock gallery') + (d ? ' <span class="st-eb-sep" aria-hidden="true">·</span> as of ' + esc(d) : '') + '</span>';
    title.textContent = CFG.heading || 'Cars in the gallery';
    truth.innerHTML = '<b class="t-num">' + M.fmt(n) + '</b> ' + plural(n, 'car', 'cars') + ' published online' +
      (hasNet() && M.netMore() ? ' <span aria-hidden="true">·</span> more in ' + esc(held()) + ' — <a href="' + esc(findUrl()) + '">ask</a>'
        : ' <span aria-hidden="true">·</span> not here? <a href="' + esc(findUrl()) + '">we source it</a>');
    aside.innerHTML = '';
    if (!CFG.tiersOn) { tiers.hidden = true; return; }
    tiers.hidden = false;
    var s = ns();
    tiers.innerHTML =
      '<div class="st-tier st-tier--on">' +
        '<dt class="t-label-s">Published online</dt>' +
        '<dd class="st-tier-n t-num">' + M.fmt(n) + '</dd>' +
        '<dd class="st-tier-t">Photographed and specified on this site. Every one is here in the list below.</dd>' +
      '</div>' +
      (hasNet() ?
      '<div class="st-tier">' +
        '<dt class="t-label-s">' + (lastCtx && lastCtx.partnerNote ? 'In partner showrooms' : 'In our showroom network') + '</dt>' +
        '<dd class="st-tier-n t-num">' + M.fmt(s.here) + ' <span class="st-tier-plus">+ ' + M.fmt(s.way) + ' on the way</span></dd>' +
        '<dd class="st-tier-t">Here now in Nairobi (' + M.fmt(s.nairobi) + ') and Mombasa (' + M.fmt(s.mombasa) + '), plus ' + M.fmt(s.way) + ' still in Japan or in transit. ' + (M.netMore() ? 'The cars published here are among them. Ask by make, model or ref.' : 'Every one of them is listed on this website.') + '</dd>' +
      '</div>' : '') +
      '<div class="st-tier">' +
        '<dt class="t-label-s">Sourced on request</dt>' +
        '<dd class="st-tier-n st-tier-n--word">Anything else</dd>' +
        '<dd class="st-tier-t">Tell us the car. We search the network, confirm availability and history, and arrange the viewing. <a class="st-inline-link" href="' + esc(findUrl()) + '">Find me a car</a></dd>' +
      '</div>';
  }

  function renderNeeds() {
    var box = root.querySelector('[data-st-needs]');
    if (!box || !CFG.needsOn) return;
    var base = facet('need');
    var html = '<button type="button" class="chip st-chip" data-st-need="" aria-pressed="' + (!S.need) + '">All <span class="st-chip-n t-num">' + M.fmt(base.length) + '</span></button>';
    M.NEEDS.forEach(function (nd) {
      var c = base.filter(nd.test).length;
      html += '<button type="button" class="chip st-chip' + (c ? '' : ' st-chip--zero') + '" data-st-need="' + nd.key + '" aria-pressed="' + (S.need === nd.key) + '">' +
        esc(nd.label) + ' <span class="st-chip-n t-num">' + M.fmt(c) + '</span>' +
        '<span class="sr-only">' + plural(c, ' car', ' cars') + '</span></button>';
    });
    box.innerHTML = html;
  }

  /* ================= render: filter rail ================= */
  function seg(name, legend, opts, cur) { /* single-choice group: native radios as calm rows */
    return '<fieldset class="st-fs"><legend class="st-legend">' + legend + '</legend><div class="st-checks">' +
      opts.map(function (o) {
        var id = 'st-' + name + '-' + (o.v || 'any');
        return '<label class="check st-check st-radio' + (o.n === 0 && cur !== o.v ? ' is-zero' : '') + '" for="' + id + '"><input type="radio" id="' + id + '" name="' + name + '" value="' + o.v + '"' + (cur === o.v ? ' checked' : '') + '><span class="st-check-l">' + esc(o.label) + '</span>' +
          (o.n != null ? '<span class="st-check-n t-num">' + M.fmt(o.n) + '</span>' : '') + '</label>';
      }).join('') + '</div></fieldset>';
  }
  function checks(k) {
    var base = facet(k), counts = countBy(base, k), vals = valuesOf(k);
    if (!vals.length) return '';
    return '<fieldset class="st-fs"><legend class="st-legend">' + GROUP[k] + '</legend><div class="st-checks">' +
      vals.map(function (o) {
        var id = 'st-' + k + '-' + o.v, n = counts[o.v] || 0, on = S[k].indexOf(o.v) > -1;
        var lab = k === 'drive' && o.v === '4wd' ? '4WD (4x4)' : o.label;
        return '<label class="check st-check' + (n || on ? '' : ' is-zero') + '" for="' + id + '"><input type="checkbox" id="' + id + '" name="' + k + '" value="' + esc(o.v) + '"' + (on ? ' checked' : '') + '><span class="st-check-l">' + esc(lab) + '</span><span class="st-check-n t-num">' + M.fmt(n) + '</span></label>';
      }).join('') + '</div></fieldset>';
  }
  function select(name, label, opts, cur, extra, srLabel) {
    var id = 'st-' + name;
    return '<div class="field st-field"><label for="' + id + '"' + (srLabel ? ' class="sr-only"' : '') + '>' + label + '</label><select class="select" id="' + id + '" name="' + name + '"' + (extra || '') + '>' +
      opts.map(function (o) { return '<option value="' + esc(o.v) + '"' + (String(cur) === String(o.v) ? ' selected' : '') + '>' + esc(o.label) + '</option>'; }).join('') + '</select></div>';
  }
  function renderRail() {
    var focusId = document.activeElement && railNode.contains(document.activeElement) ? document.activeElement.id : '';
    var sc = railNode.closest('.st-dw-scroll') || railHost; var st = sc ? sc.scrollTop : 0;

    var fs = facet('status'), fl = facet('loc');
    var stc = { in: 0, way: 0 }; fs.forEach(function (c) { stc[c.status]++; });
    var lc = countBy(fl.filter(function (c) { return c.status === 'in'; }), 'loc');

    var mkCount = {}; M.makes(facet('make')).forEach(function (m) { mkCount[m.key] = m.count; });
    var allMakes = M.makes(cars()).map(function (m) { return { v: slug(m.make), label: m.make + ' (' + M.fmt(mkCount[m.key] || 0) + ')' }; });
    /* a make in the address that this collection doesn't carry stays selectable, so the empty state can explain it */
    if (S.make && !allMakes.some(function (o) { return o.v === S.make; })) allMakes.push({ v: S.make, label: display('make', S.make) + ' (0)' });
    var modelOpts = [{ v: '', label: S.make ? 'Any model' : 'Choose a make first' }];
    if (S.make) {
      var mc = countBy(facet('model').filter(function (c) { return slug(c.make) === S.make; }), 'model');
      uniq(cars().filter(function (c) { return slug(c.make) === S.make; }).map(function (c) { return c.model; })).sort().forEach(function (m) { modelOpts.push({ v: slug(m), label: m + ' (' + M.fmt(mc[slug(m)] || 0) + ')' }); });
      if (S.model && !modelOpts.some(function (o) { return o.v === S.model; })) modelOpts.push({ v: S.model, label: display('model', S.model) + ' (0)' });
    }
    var years = uniq(cars().map(function (c) { return yr(c) ? String(yr(c)) : ''; }).concat([S.ymin, S.ymax])).sort();
    var yFrom = [{ v: '', label: 'Any' }].concat(years.map(function (y) { return { v: y, label: y }; }));
    var kmOpts = [{ v: '', label: 'Any mileage' }].concat(KM_OPTS.map(function (k) { return { v: String(k), label: 'Up to ' + M.km(k) }; }));
    var fk = facet('kmax').filter(M.kmKnown);
    kmOpts.forEach(function (o) { if (o.v) o.label += ' (' + M.fmt(fk.filter(function (c) { return c.km <= +o.v; }).length) + ')'; });

    var n = railActiveCount();
    railNode.innerHTML =
      '<div class="st-rail-head"><h2 class="t-label">Refine</h2>' +
        '<button type="button" class="st-reset" data-st-clear' + (n ? '' : ' hidden') + '>Clear all</button></div>' +
      seg('status', 'Availability', [{ v: '', label: 'All' }, { v: 'in', label: 'Here now', n: stc.in }, { v: 'way', label: 'Arriving', n: stc.way }], S.status) +
      '<fieldset class="st-fs"><legend class="st-legend">Make and model</legend><div class="st-pair st-pair--stack">' +
        select('make', 'Make', [{ v: '', label: 'Any make' }].concat(allMakes), S.make, '', true) +
        select('model', 'Model', modelOpts, S.model, S.make ? '' : ' disabled', true) +
      '</div></fieldset>' +
      (years.length ? '<fieldset class="st-fs"><legend class="st-legend">Year</legend><div class="st-pair">' +
        select('ymin', 'From', yFrom, S.ymin) + select('ymax', 'To', yFrom, S.ymax) +
      '</div></fieldset>' : '') +
      '<fieldset class="st-fs"><legend class="st-legend">Mileage</legend>' + select('kmax', 'Maximum mileage', kmOpts, S.kmax, '', true) + '</fieldset>' +
      seg('loc', 'Showroom city (here now)', [{ v: '', label: 'Both' }, { v: 'nairobi', label: 'Nairobi', n: lc.nairobi || 0 }, { v: 'mombasa', label: 'Mombasa', n: lc.mombasa || 0 }], S.loc) +
      checks('body') + checks('fuel') + checks('trans') + checks('drive') +
      (CFG.railNote ? '<p class="st-rail-note">' + esc(CFG.railNote) + '</p>' : '');

    if (focusId) { var f = document.getElementById(focusId); if (f) try { f.focus({ preventScroll: true }); } catch (e) { } }
    if (sc) sc.scrollTop = st;
  }

  /* ================= render: results ================= */
  function endTile(n, filtered) {
    var mk = viewMake(), m = netMake(mk), d = asOf();
    var h, p;
    if (S.saved) {
      h = 'Want us to check these for you?';
      p = 'Send the shortlist and we confirm what is still available, its history, and arrange viewings in Nairobi or Mombasa.';
    } else if (m && makeBeyond(mk, m)) {
      h = 'More ' + esc(mk) + ' in ' + esc(held()) + '.';
      p = '<span class="t-num">' + M.fmt(m.in || 0) + '</span> here now and <span class="t-num">' + M.fmt(m.way || 0) + '</span> arriving across the network, beyond what is published here. Tell us the model and year you want and we check what is real today.';
    } else if (hasNet() && M.netMore()) {
      h = 'Ask for any car in the network.';
      p = 'Only a selection of the stock in ' + esc(held()) + ' is published online. Tell us what you need and we look through Nairobi, Mombasa and the cars on their way.';
    } else {
      h = 'Ask for any car.';
      h = 'Not seeing the one?';
      p = 'Tell us the car you want: make, model, year and budget. We look beyond this list and source it for you.';
    }
    var wa = S.saved ? 'Hi AHIHQ Motors, can you check my saved cars for me?' : 'Hi AHIHQ Motors, I am looking for ' + (filtered.length ? filtered.join(', ') : 'a car') + '. Can you help me find one?';
    var el = document.createElement('aside');
    el.className = 'st-end on-dark tex';
    el.setAttribute('aria-label', 'Concierge');
    el.setAttribute('data-r2', n % 2); el.setAttribute('data-r3', n % 3); el.setAttribute('data-r4', n % 4);
    el.innerHTML =
      '<div class="st-end-in">' +
        '<div class="st-end-copy">' +
          (CFG.endEyebrow ? '<p class="eyebrow st-end-eb">' + esc(CFG.endEyebrow) + '</p>' : '') +
          '<h3 class="st-end-h">' + h + '</h3>' +
          '<p class="st-end-p">' + p + '</p>' +
        '</div>' +
        '<div class="st-end-cta">' +
          '<a class="btn btn--primary" href="' + esc(findUrl()) + '">Find me a car</a>' +
          '<a class="btn btn--ghost-dark" ' + M.waAttrs(wa) + '>' + M.icon('whatsapp', { size: 18 }) + 'WhatsApp</a>' +
        '</div>' +
        (!S.saved && hasNet() && d ? '<p class="st-end-src">Network figures from the stock list of ' + esc(d) + '.' + (lastCtx && lastCtx.partnerNote ? ' These are partner inventory, not cars AHIHQ Motors owns.' : '') + '</p>' : '') +
      '</div>';
    return el;
  }

  function makeBeyond(mk, m) {
    var lk = String(mk).toLowerCase(), onSite = 0;
    (M.all || []).forEach(function (c) { if (String(c.make || '').toLowerCase() === lk) onSite++; });
    return onSite < (m.in || 0) + (m.way || 0);
  }
  function netLine() {
    var mk = viewMake(), m = netMake(mk), d = asOf(), s = ns();
    var H = held(); H = H.charAt(0).toUpperCase() + H.slice(1);
    if (m) {
      // "not all listed here" only when true: the network's count for the make is higher than the site's
      var lk = String(mk).toLowerCase(), onSite = 0;
      (M.all || []).forEach(function (c) { if (String(c.make || '').toLowerCase() === lk) onSite++; });
      var more = onSite < (m.in || 0) + (m.way || 0);
      return H + ' hold <span class="t-num">' + M.fmt(m.in || 0) + '</span> ' + esc(mk) + ' here now and <span class="t-num">' + M.fmt(m.way || 0) + '</span> arriving' + (d ? ' (as of ' + esc(d) + ')' : '') + (more ? ', not all of them listed here.' : ', all of them listed here.');
    }
    if (hasNet()) return H + ' hold <span class="t-num">' + M.fmt(s.here) + '</span> cars here now and <span class="t-num">' + M.fmt(s.way) + '</span> on the way' + (d ? ' (as of ' + esc(d) + ')' : '') + (M.netMore() ? ', not all of them listed here.' : ', all of them listed here.');
    return '';
  }
  function emptyState(filtered) {
    var el = document.createElement('div');
    el.className = 'st-empty';
    if (S.saved) {
      el.innerHTML =
        '<span class="st-empty-ic" aria-hidden="true">' + M.icon('heart', { size: 28 }) + '</span>' +
        '<h3 class="t-display-s">No saved cars yet.</h3>' +
        '<p>Tap the heart on any car to keep it here. Saved cars stay in this browser only.</p>' +
        '<div class="st-empty-cta"><a class="btn btn--primary" href="' + esc(allUrl()) + '">Browse the gallery</a></div>';
      return el;
    }
    var wa = 'Hi AHIHQ Motors, I am looking for ' + (filtered.length ? filtered.join(', ') : 'a car') + '. Can you find one for me?';
    var nothing = !cars().length;
    el.innerHTML =
      '<span class="st-empty-ic" aria-hidden="true">' + M.icon('compass', { size: 28 }) + '</span>' +
      '<p class="eyebrow">' + (nothing ? 'Nothing published here yet' : 'Nothing published matches') + '</p>' +
      '<h3 class="t-display-s">We can still look for ' + (filtered.length ? '<span class="st-empty-q">' + esc(filtered.join(' · ')) + '</span>' : 'it') + '.</h3>' +
      '<p>' + netLine() + ' Anything else can be sourced. Tell the concierge what you need.</p>' +
      '<div class="st-empty-cta">' +
        '<a class="btn btn--primary" href="' + esc(findUrl()) + '">Ask the concierge to find it</a>' +
        '<a class="btn btn--secondary" ' + M.waAttrs(wa) + '>' + M.icon('whatsapp', { size: 18 }) + 'WhatsApp</a>' +
        (filtered.length ? '<button type="button" class="text-link st-empty-clear" data-st-clear>Clear filters <span class="arr" aria-hidden="true">→</span></button>' : '') +
      '</div>';
    return el;
  }

  var SIZES = '(max-width: 600px) 100vw, (max-width: 1100px) 45vw, 340px';
  /* append cards [from, limit) and then either the "Show more" row or the closing tile */
  function paint(grid, from, labels) {
    var old = grid.querySelector('[data-st-morebox]'); if (old) old.remove();
    var frag = document.createDocumentFragment();
    var to = Math.min(limit, res.length);
    for (var i = from; i < to; i++) frag.appendChild(M.card(res[i], { eager: i < 3, sizes: SIZES }));
    if (to < res.length) {
      var left = res.length - to, next = Math.min(CHUNK, left);
      var box = document.createElement('div');
      box.className = 'st-more'; box.setAttribute('data-st-morebox', '');
      box.innerHTML = '<p class="st-more-n">Showing <b class="t-num">' + M.fmt(to) + '</b> of <span class="t-num">' + M.fmt(res.length) + '</span></p>' +
        '<button type="button" class="btn btn--secondary st-more-btn" data-st-more>Show ' + M.fmt(next) + ' more ' + plural(next, 'car', 'cars') + '</button>';
      frag.appendChild(box);
    } else {
      frag.appendChild(endTile(res.length, labels));
    }
    grid.appendChild(frag);
  }
  function showMore() {
    var grid = root.querySelector('[data-st-grid]');
    var from = Math.min(limit, res.length);
    limit += CHUNK;
    paint(grid, from, S.saved ? [] : active().map(function (a) { return a.label; }));
    var first = grid.querySelectorAll('.vc')[from];
    var a = first && first.querySelector('.vc-title a'); if (a) try { a.focus({ preventScroll: false }); } catch (e) { }
  }

  function renderResults() {
    var list = cars();
    res = S.saved ? list.filter(function (c) { return M.isSaved(c.ref); }) : list.filter(function (c) { return matches(c, S); });
    res = sortCars(res);
    var act = S.saved ? [] : active();
    var labels = act.map(function (a) { return a.label; });

    /* count line */
    var cnt = root.querySelector('[data-st-count]');
    if (S.saved) cnt.innerHTML = '<b class="t-num">' + M.fmt(res.length) + '</b> saved';
    else cnt.innerHTML = act.length
      ? '<b class="t-num">' + M.fmt(res.length) + '</b> of <span class="t-num">' + M.fmt(list.length) + '</span> published ' + plural(list.length, 'car', 'cars')
      : 'All <b class="t-num">' + M.fmt(res.length) + '</b> published ' + plural(res.length, 'car', 'cars');

    /* filters button + sort */
    var rn = railActiveCount();
    var fc = root.querySelector('[data-st-fcount]'); fc.textContent = rn ? rn : ''; fc.hidden = !rn;
    root.querySelector('[data-st-open]').setAttribute('aria-label', 'Filters' + (rn ? ', ' + rn + ' active' : ''));
    var so = root.querySelector('[data-st-sort]');
    so.innerHTML = SORTS.map(function (o) { return '<option value="' + o[0] + '"' + (S.sort === o[0] ? ' selected' : '') + '>' + o[1] + '</option>'; }).join('');

    /* pills */
    var pills = root.querySelector('[data-st-pills]');
    pills.innerHTML = act.length ? '<span class="sr-only">Active filters:</span>' + act.map(function (a) {
      return '<button type="button" class="st-pill" data-st-rm="' + a.k + '" data-st-rv="' + esc(a.v || '') + '" aria-label="Remove filter ' + esc(a.label) + '">' + esc(a.label) + '<span class="st-pill-x" aria-hidden="true">' + M.icon('close', { size: 14, stroke: 1.8 }) + '</span></button>';
    }).join('') + (act.length > 1 ? '<button type="button" class="st-pill st-pill--clear" data-st-clear>Clear all</button>' : '') : '';
    pills.hidden = !act.length;

    /* grid */
    var grid = root.querySelector('[data-st-grid]');
    grid.innerHTML = '';
    grid.classList.toggle('is-empty', !res.length);
    if (!res.length) grid.appendChild(emptyState(labels));
    else paint(grid, 0, labels);

    /* drawer footer */
    if (drawer) {
      var sb = drawer.el.querySelector('[data-st-show]'); if (sb) sb.textContent = res.length ? 'Show ' + M.fmt(res.length) + plural(res.length, ' car', ' cars') : 'Show results';
      var cb = drawer.el.querySelector('[data-st-dclear]'); if (cb) cb.disabled = !rn;
    }
    return res;
  }

  function update() {
    limit = CHUNK;
    writeUrl();
    if (!S.saved) { renderRail(); renderNeeds(); }
    renderResults();
    M.syncSaved();
  }

  /* ================= drawer (phone) ================= */
  function openDrawer() {
    if (drawer) return;
    var wrap = document.createElement('div');
    wrap.className = 'st-dw';
    wrap.innerHTML =
      '<div class="st-dw-head"><h2 class="t-display-s">Filters</h2></div>' +
      '<div class="st-dw-scroll"></div>' +
      '<div class="st-dw-foot"><button type="button" class="btn btn--secondary st-dw-clear" data-st-dclear>Clear all</button>' +
      '<button type="button" class="btn btn--primary st-dw-show" data-st-show>Show results</button></div>';
    wrap.querySelector('.st-dw-scroll').appendChild(railNode);
    drawer = M.modal({
      label: 'Filters', content: wrap, cls: 'st-drawer', focus: '.st-dw-scroll input, .st-dw-scroll select',
      onClose: function () { drawer = null; railHost.appendChild(railNode); root.querySelector('[data-st-open]').setAttribute('aria-expanded', 'false'); }
    });
    root.querySelector('[data-st-open]').setAttribute('aria-expanded', 'true');
    wrap.addEventListener('click', function (e) {
      if (e.target.closest('[data-st-show]')) { drawer.close(); return; }
      if (e.target.closest('[data-st-dclear]')) { clearAll(); update(); }
    });
    renderResults();
  }
  function closeDrawer() { if (drawer) drawer.close(); }

  /* ================= events ================= */
  function onRailChange(e) {
    var t = e.target, name = t.name; if (!name) return;
    if (name === 'status' || name === 'loc') S[name] = t.value;
    else if (name === 'make') { S.make = t.value; S.model = ''; }
    else if (name === 'model' || name === 'kmax') S[name] = t.value;
    else if (name === 'ymin' || name === 'ymax') {
      S[name] = t.value;
      if (S.ymin && S.ymax && +S.ymin > +S.ymax) { if (name === 'ymin') S.ymax = S.ymin; else S.ymin = S.ymax; }
    }
    else if (MULTI.indexOf(name) > -1) { S[name] = t.checked ? uniq(S[name].concat(t.value)) : S[name].filter(function (v) { return v !== t.value; }); }
    else return;
    update();
  }

  function readCfg(el) {
    var d = function (k) { return el.getAttribute('data-st-' + k) || ''; };
    CFG = {
      heading: d('heading'), eyebrow: d('eyebrow'), coll: d('coll'), all: d('all') === '1',
      tiersOn: d('tiers-on') !== '0', needsOn: d('needs-on') !== '0',
      endEyebrow: el.hasAttribute('data-st-end-eyebrow') ? d('end-eyebrow') : 'Beyond the gallery',
      railNote: el.hasAttribute('data-st-rail-note') ? d('rail-note') : 'No price filter: prices are given on request, per car.'
    };
  }

  function init(el) {
    slotEl = el;
    readCfg(el);
    root = el.querySelector('.st') || el;
    railNode = root.querySelector('[data-st-rail]');
    railHost = root.querySelector('[data-st-railhost]');
    root.querySelector('.st-search-ic').innerHTML = M.icon('search', { size: 20 });
    root.querySelector('[data-st-qclear]').innerHTML = M.icon('close', { size: 18 });
    root.querySelector('.st-filters-ic').innerHTML = M.icon('sliders', { size: 18 });

    railNode.addEventListener('change', onRailChange);
    railNode.addEventListener('click', function (e) { if (e.target.closest('[data-st-clear]')) { clearAll(); update(); } });

    var qi = root.querySelector('[data-st-q]'), qc = root.querySelector('[data-st-qclear]');
    qi.addEventListener('input', function () {
      qc.hidden = !qi.value; clearTimeout(qTimer);
      qTimer = setTimeout(function () { S.q = qi.value; update(); }, 160);
    });
    root.querySelector('[data-st-search-form]').addEventListener('submit', function (e) { e.preventDefault(); clearTimeout(qTimer); S.q = qi.value; update(); qi.blur(); });
    qc.addEventListener('click', function () { qi.value = ''; qc.hidden = true; S.q = ''; update(); qi.focus(); });

    root.querySelector('[data-st-sort]').addEventListener('change', function (e) { S.sort = e.target.value; update(); });

    root.addEventListener('click', function (e) {
      if (e.target.closest('.st-rail')) return;
      if (e.target.closest('[data-st-more]')) { showMore(); return; }
      var nd = e.target.closest('[data-st-need]');
      if (nd) { var k = nd.getAttribute('data-st-need'); S.need = S.need === k ? '' : k; update(); var again = root.querySelector('[data-st-need="' + k + '"]'); if (again) again.focus({ preventScroll: true }); return; }
      var rm = e.target.closest('[data-st-rm]');
      if (rm) {
        removeFilter(rm.getAttribute('data-st-rm'), rm.getAttribute('data-st-rv'));
        update();
        var next = root.querySelector('.st-pill') || root.querySelector('[data-st-q]'); if (next) next.focus({ preventScroll: true });
        return;
      }
      if (e.target.closest('[data-st-clear]')) { clearAll(); update(); var q2 = root.querySelector('[data-st-q]'); if (q2) q2.focus({ preventScroll: true }); return; }
      if (e.target.closest('[data-st-open]')) { openDrawer(); return; }
    });

    /* the phone drawer is only for ≤900px: close it if the viewport grows past that */
    window.addEventListener('resize', function () { if (drawer && root.getBoundingClientRect().width > 900) closeDrawer(); });
    document.addEventListener('mock:saved', function () {
      if (!took || !S.saved) return;
      var y = window.pageYOffset;
      renderHead(); renderResults();
      window.scrollTo(0, y);
    });
  }

  function render(el, ctx) {
    lastCtx = ctx;
    /* the feed failed (or is empty) but Liquid rendered cars: keep the server-rendered grid and its pager */
    var grid0 = el.querySelector('[data-st-grid]');
    var ssr = grid0 ? +(grid0.getAttribute('data-st-ssr') || 0) : 0;
    var params = (ctx.route && ctx.route.params) || {};
    var savedView = params.saved === '1' || params.saved === 1 || params.saved === 'true';
    if (!took && !savedView && !(ctx.all && ctx.all.length) && ssr > 0) return;

    if (!root) init(el);
    if (!took) { took = true; root.classList.add('st--js'); }
    /* a new route object = a real navigation (M.go on this page); our own replaceState keeps the same one */
    if (ctx.route && ctx.route !== lastRoute) {
      lastRoute = ctx.route;
      S = fromParams(params);
      limit = CHUNK;
      var qi = root.querySelector('[data-st-q]'); qi.value = S.q; root.querySelector('[data-st-qclear]').hidden = !S.q;
      closeDrawer();
      if (params.focus === 'search' && !S.saved) {
        setTimeout(function () { try { qi.focus({ preventScroll: false }); } catch (x) { } }, 0);
      }
      writeUrl(); /* canonicalise the address (drops focus=search and ?page=N; the full list is on one page now) */
    }
    renderHead();
    if (!S.saved) { renderNeeds(); renderRail(); }
    renderResults();
  }

  M.view('stock', { init: function () { }, render: render });
  /* The home finder asks the stock page for its count, so "Show N cars" always equals what lands. */
  M.stockCount = function (params) { var s = fromParams(params || {}); return M.cars.filter(function (c) { return matches(c, s); }).length; };
})();
